export enum CouponType {
    Fixed = "fixed",
    Percentage = "percentage",
}
